// Prod_US menu (person page, left of the header): the app's side drawer (mmt-menu-drawer,
// mmtuserlist.scss) with the Prod_US items. Delete my data and Logout ask first.
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import closeIcon from "../../assets/images/closeIcon.svg";
import InitialsAvatar from "../plugInElements/InitialsAvatar";
import "../mmtUserList/mmtuserlist.scss";
import { openExternalUrl } from "../../utlis/webViewBridge";
import { signOutFirebase, currentUser } from "./firebasePhoneAuth";
import { deleteProdUsMe } from "./prodUsApi";
import { clearProdUsSession } from "./prodUsSession";
import { clearProdUsVideos } from "./prodUsVideoHold";
import { maskPhone } from "./prodUsRules";
import { URLS } from "./prodUsConfig";
import { pt } from "./prodUsStrings";

export const PROD_US_HOME = "/mobility-check";

const PATHS = {
  report: (
    <>
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
      <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" />
    </>
  ),
  sample: <path d="M18 20V10M12 20V4M6 20v-6" />,
  privacy: <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />,
  terms: (
    <>
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
      <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" />
    </>
  ),
  support: (
    <path d="M21 11.5a8.5 8.5 0 01-12.3 7.6L3 21l1.9-5.7A8.5 8.5 0 1121 11.5z" />
  ),
  delete: <path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6" />,
  logout: (
    <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" />
  ),
};

const Entry = ({ icon, title, description, onClick, red }) => (
  <button
    type="button"
    className={`mmt-menu-item${red ? " pu-red" : ""}`}
    onClick={onClick}
  >
    <span className="mmt-menu-item-icon">
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke={red ? "#b91c1c" : "#054997"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        {PATHS[icon]}
      </svg>
    </span>
    <span className="mmt-menu-item-text">
      <strong>{title}</strong>
      <span>{description}</span>
    </span>
  </button>
);

const ProdUsMenu = ({ open, onClose, person, onViewReport, onDeleted }) => {
  const navigate = useNavigate();
  const [confirm, setConfirm] = useState(null); // "delete" | "logout"
  const [busy, setBusy] = useState(false);
  const name = person
    ? `${person.first_name || ""}. ${person.last_name || ""}.`
    : "";

  const leave = async () => {
    clearProdUsVideos();
    await signOutFirebase().catch(() => {});
    clearProdUsSession();
    navigate(PROD_US_HOME, { replace: true });
  };

  const doDelete = async () => {
    setBusy(true);
    try {
      await deleteProdUsMe();
      onDeleted?.(pt("del_done"));
      await leave();
    } finally {
      setBusy(false);
      setConfirm(null);
    }
  };

  const go = (url) => {
    onClose();
    openExternalUrl(url);
  };

  return (
    <>
      <div
        className={`mmt-drawer-overlay ${open ? "is-open" : ""}`}
        aria-hidden={!open}
      >
        <button
          className="mmt-drawer-backdrop"
          onClick={onClose}
          aria-label={pt("menu")}
        />
        <aside className="mmt-menu-drawer">
          <button
            className="mmt-menu-close"
            onClick={onClose}
            aria-label={pt("menu")}
          >
            <img src={closeIcon} alt="" />
          </button>
          {person ? (
            <>
              <div className="mmt-menu-profile">
                <InitialsAvatar
                  className="mmt-menu-avatar mmt-staff-initials"
                  name={`${person.first_name} ${person.last_name}`}
                  size={56}
                />
                <div className="mmt-menu-profile-info">
                  <strong>{name}</strong>
                  <span>{maskPhone(currentUser()?.phoneNumber)}</span>
                </div>
              </div>
              <div className="mmt-menu-divider" />
            </>
          ) : null}
          <nav className="mmt-menu-items">
            {onViewReport ? (
              <Entry
                icon="report"
                title={pt("view_report")}
                description={pt("view_report_d")}
                onClick={() => {
                  onClose();
                  onViewReport();
                }}
              />
            ) : null}
            {URLS.sampleReport ? (
              <Entry
                icon="sample"
                title={pt("sample_btn")}
                description={pt("sample_d")}
                onClick={() => go(URLS.sampleReport)}
              />
            ) : null}
            <Entry
              icon="privacy"
              title={pt("m_privacy")}
              description={pt("m_privacy_d")}
              onClick={() => go(URLS.privacy)}
            />
            <Entry
              icon="terms"
              title={pt("m_terms")}
              description={pt("m_terms_d")}
              onClick={() => go(URLS.terms)}
            />
            <Entry
              icon="support"
              title={pt("m_support")}
              description={pt("m_support_d")}
              onClick={() => go(URLS.contact)}
            />
            <Entry
              icon="delete"
              red
              title={pt("m_delete")}
              description={pt("m_delete_d")}
              onClick={() => {
                onClose();
                setConfirm("delete");
              }}
            />
            <Entry
              icon="logout"
              title={pt("m_logout")}
              description={pt("m_logout_d")}
              onClick={() => {
                onClose();
                setConfirm("logout");
              }}
            />
          </nav>
        </aside>
      </div>

      {confirm ? (
        <div className="mmt-confirm-overlay">
          <div className="mmt-confirm-dialog" role="dialog" aria-modal="true">
            <strong>
              {pt(confirm === "delete" ? "del_title" : "m_logout")}
            </strong>
            <p>{pt(confirm === "delete" ? "del_body" : "m_logout_d")}</p>
            <div className="mmt-confirm-actions">
              <button
                type="button"
                onClick={() => setConfirm(null)}
                disabled={busy}
              >
                {pt("cancel")}
              </button>
              <button
                type="button"
                className="mmt-confirm-destructive"
                disabled={busy}
                onClick={confirm === "delete" ? doDelete : leave}
              >
                {pt(confirm === "delete" ? "del_btn" : "m_logout")}
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default ProdUsMenu;
